export * from './search-source.service';
export * from './search.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/search/shared/index.ts